export const retail_heading = [
    {
        title: "Navigating the Next"      
    },
    {
        title: "Wave of E-Commerce"
    },
  ];